import React, { Component } from "react";
import {Panel} from 'react-bootstrap';

import { Glyphicon, Col, OverlayTrigger, Form, FormGroup} from 'react-bootstrap';
import {tooltip} from '../Utils';

//Services
import {JobActionService} from '../Services/JobActionService';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Modal from '@material-ui/core/Modal';  
import Divider from '@material-ui/core/Divider';

function getModalStyle() {
    const top = 50 ;
    const left = 50 ;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const styles = theme => ({
    fab: {
        margin: theme.spacing.unit,
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    textField: {
        width: 200,
        margin: 0,
        marginTop: 10,
        height: 50
    },
    table: {
        minWidth: 500,
    },
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        outline: 'none',
    }
  });

class ManageJobActions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            job_actions_modal: { name: ''},
            job_actions: [],
            job_actions_rows: [],
            show: false
        };
    }

    componentWillMount(){
        this.props.setTitle("Manage Job Actions");
        this.fetchJobActions();
    }

    handleClose = () => {
        this.setState({ show: false });
        this.setState({
            job_actions_modal: { name: ''}
        });
    }

    handleShow = () => {
        this.setState({ show: true });
    }


    fetchJobActions(){
        this.props.isLoading(true);
        JobActionService.getJobActions()
        .then((data) => {
            console.log(data);
            let list = [];
            data.job_actions.forEach((element, index) => {
                list.push(<JobActionDetails key={index} item={element} edit={this.edit} removeJobAction={this.removeJobAction}/>);
            });
            
            this.setState({job_actions: data.job_actions, job_actions_rows: list});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleChange = (e) => {
        e.preventDefault();
        let change = {};
        change = this.state.job_actions_modal;
        change[e.target.name] = e.target.value;
        this.setState({job_actions_modal: change});
    }

    removeJobAction = (e, id) => {
        e.preventDefault();
        if(id) {
            this.props.showConfirmDialog("This will not effect any of the existing Projects.", "Confirm removal of Job Action?", () => {
                let headers = {user_id : this.props.user.id };
                JobActionService.removeJobAction(headers, id)
                .then(() =>{
                    this.fetchJobActions();
                    this.props.closeConfirmDialog();
                    this.props.showSnackBar(`Removed Job Action`, 'success');
                })
                .catch((error) => {
                    this.props.showSnackBar(`Failed to remove Job Action. Please try again.`, 'error');
                });
            });
        }
    }

    proceed = () => {
        let {id} = this.state.toRemove; 
        JobActionService.removeJobAction(id)
        .then(() =>{
            this.fetchJobActions();
            this.setState({toRemove: {}});
            this.props.closeConfirmDialog();
            this.props.showSnackBar(`Removed Job Action`, 'success');
        })
        .catch((error) => {
            this.props.showSnackBar(`Failed to remove Job Action. Please try again.`, 'error');
        });
    }

    saveJobAction = (e) => {
        e.preventDefault();
        let modal = this.state.job_actions_modal;
        
        if(modal.name.length > 0 && (modal.id || this.alreadyExists(modal.name).length === 0)){
            let headers = {'user_id' : this.props.user.id};
            JobActionService.createJobAction(headers, modal)
            .then((response) => {
                if(response.status === 409){
                    this.props.showSnackBar(`${modal.name} already exists.`, 'error');
                } else {
                    this.fetchJobActions();
                    this.handleClose();
                    this.setState({job_action_modal: { name: ''}});
                    this.props.showSnackBar(`${modal.id ? 'Saved' : 'Created'} Job Action: ${modal.name}`, 'success');
                }
            })
            .catch(() => {
                this.props.showSnackBar(`Failed to create Job Action: ${modal.name}. Please try again.`, 'error');
            });
        } else {
            this.props.showSnackBar(`${modal.name} already exists.`, 'error');
        }
    }

    alreadyExists(name){
        return this.state.job_actions.filter((item) => item.name === name);
    }

    render() {
        const { classes } = this.props;
        return ( 
            <div className="Home">
                <Paper className={classes.root}>
                    <Table className={classes.table}>
                        <TableHead>
                        <TableRow>
                            <TableCell>
                                <Typography variant="title">Job Actions
                                </Typography>
                            </TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.job_actions_rows}
                        </TableBody>
                    </Table>
                </Paper>
                <Modal 
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.show} 
                    onClose={this.handleClose}>
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography variant="h6" id="modal-title">
                            { this.state.job_actions_modal.id ? 'Modify Job Action' : 'Create Job Action' }
                        </Typography>
                        <Divider />
                        <Form inline onSubmit={(e)=> this.saveJobAction(e)}>
                            <FormGroup  validationState={this.getValidationStateReason()}>
                                
                                <Col sm={9}>
                                    <TextField
                                        id="name"
                                        className={classes.textField}
                                        variant="outlined"
                                        label="Job Actions"
                                        margin="normal"
                                        value={this.state.job_actions_modal.name}
                                        name="name"
                                        onChange={(e) => this.handleChange(e)}
                                        type="text"
                                        required />
                                </Col>
                                <Col sm={3}>
                                    <Button type="submit" variant="outlined" size="medium" color="primary" style={{marginTop: '20px'}} onClick={(e)=> this.saveJobAction(e)}>Save</Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </div>
                </Modal>
                <OverlayTrigger placement="top" overlay={tooltip("Add Job Action")} >
                    <Fab onClick={this.edit} color="primary" aria-label="Add" className={classes.fab}>
                        <AddIcon />
                    </Fab>
                </OverlayTrigger>
                {/* {this.reasonBlock("Job Actions", this.saveJobAction, this.state.job_actions_rows, this.state.job_actions_modal)}                 */}
            </div>
        );
    }

    edit = (e, job_action) => {
        e.preventDefault();
        if(job_action){
            this.setState({ job_actions_modal: { name: job_action.name, id: job_action.id} }, function () {
                this.handleShow();
            });
        } else {
            this.handleShow();
        }
    }

    getValidationStateReason(){
        let modal = this.state.job_actions_modal;

        if(modal.name){
            const length = modal.name.length;
            if (length > 1 && this.alreadyExists(modal.name).length === 0) return 'success';
            else return 'warning';
        }
        return null;
    }

    reasonBlock = (title, submitFunction, list, modal) => (
                    
                            <Typography style={{width: "100%"}} gutterBottom>
                                <Panel>
                                    <Panel.Body style={{backgroundColor: "white"}}>
                                        
                                        <Col xs={12}>
                                            <Table striped condensed hover responsive>
                                                <thead>
                                                    <tr>
                                                        <th>Job Actions</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Panel.Body>
                                </Panel>
                            </Typography>
    )
}

class JobActionDetails extends Component {
     /* <tr>
                    <td style={{textAlign: "left", paddingLeft: "20px"}}>{item.name}</td>
                    <td>
                        <OverlayTrigger placement="bottom" overlay={tooltip("Remove Job Action")}>
                            <Glyphicon style={{marginRight: "10px"}} glyph="trash" onClick={(e) => this.props.removeJobAction(e, item.id)}/>
                        </OverlayTrigger>
                    </td>
                </tr> */

    render() {
        const item = this.props.item;
        return (
                <TableRow>
                    <TableCell component="th" scope="row">
                        <Typography variant="subtitle1">
                            {item.name}
                        </Typography>
                    </TableCell>
                    <TableCell align="right">   
                        <OverlayTrigger placement="bottom" overlay={tooltip("Remove Job Action")}>
                            <Glyphicon style={{marginRight: "20px"}} glyph="trash" onClick={(e) => this.props.removeJobAction(e, item.id)}/>
                        </OverlayTrigger>
                        <OverlayTrigger placement="bottom" overlay={tooltip("Edit")} >
                            <Glyphicon style={{marginRight: "10px"}} glyph="pencil" onClick={(e) => this.props.edit(e, item)}/>
                        </OverlayTrigger>
                    </TableCell>
                </TableRow>
        );
    }
}

export default withStyles(styles)(ManageJobActions);